import { Camera, Upload } from 'lucide-react';

const ModeToggle = ({ mode, onModeChange }) => (
  <div className="flex justify-center gap-4 mb-6">
    <button
      onClick={() => onModeChange('camera')}
      className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all ${
        mode === 'camera'
          ? 'bg-primary text-white shadow-md'
          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
      }`}
    >
      <Camera size={20} />
      Camera
    </button>
    
    <button
      onClick={() => onModeChange('upload')}
      className={`flex items-center gap-2 px-6 py-3 rounded-lg font-semibold transition-all ${
        mode === 'upload'
          ? 'bg-primary text-white shadow-md'
          : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
      }`}
    >
      <Upload size={20} />
      Upload
    </button>
  </div>
);

export default ModeToggle;
